import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import ConfirmModal from '../ui/ConfirmModal';
import projectService from '../../services/projectService';
import Toast from '../Toast';

const DeleteThreadModal = ({ onClose, refetch, _id }) => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const resp = await projectService.deleteProjectSession({
        project_id: id,
        session_id: _id,
      });
      Toast({ type: 'success', message: resp?.detail });
      refetch();
      onClose();
    } catch (error) {
      Toast({ type: 'error', message: 'Something went wrong' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmModal
      title="Delete Thread"
      message={<p>Are you sure you want to delete this chat thread? This action cannot be undone.</p>}
      confirmLabel={loading ? 'Deleting...' : 'Delete'}
      loading={loading}
      onConfirm={handleSubmit}
      onClose={onClose}
    />
  );
};

export default DeleteThreadModal;
